export default class Special_69 {
    constructor() {
        this.init();
    }
    init(){
        this.flexnumber()
    }
    flexnumber() {
        const target = document.querySelector(".l-footer");
        const fxdElm = document.querySelector(".content__number");
        const mv = document.querySelector(".header__bg");
    
        const option = {
            root: null,
            rootMargin: "0px",
            threshold: [0],
        };
        // 交差した際の処理を記載
        const callback1 = function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    fxdElm.classList.remove("-show");
                } else {
                    fxdElm.classList.add("-show");
                }
            });
        };
        const callback2 = function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    fxdElm.classList.remove("-show");
                } else {
                    fxdElm.classList.add("-show");
                }
            });
        };
        const observer1 = new IntersectionObserver(callback1, option);
        const observer2 = new IntersectionObserver(callback2, option);
        observer1.observe(target); // 監視を開始
        observer2.observe(mv); // 監視を開始
    }
}


